import { render, staticRenderFns } from "./card-attributes.vue?vue&type=template&id=4b89af05&scoped=true"
import script from "./card-attributes.vue?vue&type=script&lang=js"
export * from "./card-attributes.vue?vue&type=script&lang=js"
import style0 from "./card-attributes.vue?vue&type=style&index=0&id=4b89af05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b89af05",
  null
  
)

export default component.exports